// @flow

import noop from 'lodash.noop';
import isObject from 'lodash.isobject';

import type {IStorage, SetDataStructure} from './typedef';

const serialize = data => {
    return isObject(data) ? JSON.stringify(data) : data;
};

// TODO: This is a temporary solution. Complex structures should be stored in IndexedDB
const _getOverflowStorageInfo = (storage: Storage) => {
    const items = [];

    for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key) {
            items.push({key, size: storage.getItem(key)?.length || 0});
        }
    }

    return items.sort((a, b) => b.size - a.size).slice(0, 10);
};

const deserialize = (data: ?string): any => {
    let retData = null;
    if (data) {
        try {
            retData = JSON.parse(data);
        } catch (e) {
            retData = data;
        }
    }
    return retData;
};

/*
    TODO: should be rafactored!!! `storage: Storage` needs to be moved to constructor
     and there are should not be any static fields
 */

const getStorage = (storage: Storage): IStorage => {
    class Storage {
        static get(key: string) {
            return deserialize(storage.getItem(key));
        }

        static set(key: string, value: any) {
            try {
                storage.setItem(key, serialize(value));
            } catch (e) {
                 
                console.error('LocalStorage is full\n', e, _getOverflowStorageInfo(storage));
                storage.clear();
            }
        }

        static bulkSet(data: Array<SetDataStructure>) {
            data.forEach(({key, value}) => {
                this.set(key, value);
            });
        }

        static remove(key: string) {
            storage.removeItem(key);
        }

        static bulkRemove(data: Array<string>) {
            data.forEach(key => {
                this.remove(key);
            });
        }

        static clear() {
            storage.clear();
        }

        static clearExcept(exceptKeys: Array<string>) {
            Object.keys(storage).forEach(key => {
                if (!exceptKeys.includes(key)) {
                    storage.removeItem(key);
                }
            });
        }
    }

    return Storage;
};

const stubStorage: IStorage = {
    get: noop,
    set: noop,
    bulkSet: noop,
    remove: noop,
    bulkRemove: noop,
    clear: noop,
    clearExcept: noop
};

let LocalStorage: IStorage;
let SessionStorage: IStorage;

try {
    LocalStorage = getStorage(localStorage);
    SessionStorage = getStorage(sessionStorage);
} catch (e) {
    LocalStorage = stubStorage;
    SessionStorage = stubStorage;
}
export {LocalStorage, SessionStorage};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
